const getFirstNumberValue = (
  source: Record<string, unknown> | null | undefined,
  keys: string[],
) => {
  for (const key of keys) {
    const value = source?.[key];
    if (value === null || value === undefined || value === "") continue;
    const parsed = Number(value);
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
};

export const resolveUsageEventDisplayCostMicrousd = (
  entry: Record<string, unknown>,
) => {
  const signedDisplayMicrousd = getFirstNumberValue(entry, [
    "display_cost_microusd",
  ]);
  if (signedDisplayMicrousd !== null) return signedDisplayMicrousd;

  return getFirstNumberValue(entry, [
    "workUnitsDisplayMicrousd",
    "work_units_display_microusd",
  ]);
};
